// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2OTd0","productName":"Table_productName__1hr9W"};